export default __webpack_public_path__ + "static/media/matchstick.8987e6b6.jpeg";